<template>
	<div class="scene-wrapper">
		<SceneHeading :imgUrl="imgUrl" :altText="altText"/>
		<TabCard class="tab-card" :tabs="Object.values(slots)">
			<template v-slot:tab-label="slot">
				<span>{{ slot.name }}</span>
			</template>
			<template v-slot:tab-body="slot">
				<TrickList
					trickType="TrickDetail"
					:tricks="tricksBySlot(slot)"
					@trick-selected="trySelect"
				/>
			</template>
		</TabCard>
		<div class="purchase-container">
			<div class="label">{{ ui.cash_label }}</div>
			<div class="amount">$<AnimatedNumber :number="unallocatedFundBalance" /></div>
			<Button class="purchase-btn" :action="complete">{{ buttonText }}</Button>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AnimatedNumber from '@/components/base/AnimatedNumber';
import Button from '@/components/base/Button';
import SceneHeading from '@/components/partials/SceneHeading';
import TabCard from '@/components/base/TabCard';
import TrickList from '@/components/game/shop/TrickList';

export default {
	name: 'MagicShop',
	components: {
		AnimatedNumber,
		Button,
		SceneHeading,
		TabCard,
		TrickList,
	},
	data() {
		return {
			initialTab: 'opener',
			imgUrl: `/static/magic-shop-title.svg`,
			altText: 'Magic Shop',
		};
	},
	computed: {
		...mapState("global/api", {
			ui: (state) => state.data.ui.shop,
		}),
		...mapGetters({
			slots: "game/performance/slots",
			tricksBySlot: "game/tricks/bySlot",
			selectedTricks: "game/tricks/selected",
			shopFund: "game/funds/spendable",
		}),
		buttonText() {
			return this.selectedTricks.length ? this.ui.buy_button_text : this.ui.skip_button_text;
		},
		unallocatedFundBalance() {
			return this.shopFund.balance
				- this.selectedTricks.reduce((total, trick) => total + trick.cost, 0);
		},
	},
	methods: {
		complete() {
			this.$router.push('/game/magic-shop/complete');
			this.$store.dispatch("sound/fx/play", { id: "button_affirmative" });
		},
		trySelect(trick) {
			if (!trick.owned && !trick.selected && this.unallocatedFundBalance >= trick.cost) {
				this.$store.dispatch(`game/tricks/${trick.id}/toggleSelection`, this.shopFund);
				this.$store.dispatch("sound/fx/play", { id: "trick_purchase" });
			} else if (!trick.owned && trick.selected) {
				this.$store.dispatch(`game/tricks/${trick.id}/toggleSelection`, this.shopFund);
				this.$store.dispatch("sound/fx/play", { id: "button_negative" });
			} else {
				this.$store.dispatch("sound/fx/play", { id: "button_negative" });
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	.tab-card {
		margin-top: 15vmin;

		@include mobile { margin-bottom: 2vmin; }
		@include tablet { margin-top: 18vmin; }
		@include desktop { margin-top: 10vmin }
		@include desktop-sm { margin-top: 15vmin; }
	}

	.purchase-container {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		margin-top: 3vmin;
	}

	.label {
		color: $body-txt-color;
		font-family: $body-font-script;
		font-size: $font-size-x-lg;
		letter-spacing: $letter-spacing-script;
		line-height: $line-height-script;
		text-transform: uppercase;
		box-sizing: content-box;
		width: 11ch;
		text-align: center;

		@include mobile { font-size: $font-size-sm; }
	}

	.amount {
		color: $body-txt-color;
		font-size: $heading-size-lg;
		text-align: center;
		z-index: $z-bottom;
		margin: 0 20px;

		@include mobile { font-size: $heading-size-sm; }
	}

</style>



// WEBPACK FOOTER //
// src/components/game/scenes/MagicShop.vue